// Formatage d'affichage pur (heures, prix) — partagé T1/T2. Aucune dépendance.

// Epoch ms -> "HH:MM" (heure locale, 2 chiffres).
export function formatHeure(epoch: number): string {
  const d = new Date(epoch);
  const h = String(d.getHours()).padStart(2, '0');
  const m = String(d.getMinutes()).padStart(2, '0');
  return `${h}:${m}`;
}

// Nombre (euros) -> "12,00 €" (affichage indicatif seul — jamais de logique caisse).
export function formatEuros(montant: number): string {
  return `${montant.toFixed(2).replace('.', ',')} €`;
}

// Modificateur D6 -> libellé écran : "-champignons" -> "SANS champignons",
// "+parmesan" -> "+ parmesan". Tout autre jeton est rendu tel quel.
export function formatMod(mod: string): string {
  if (mod.startsWith('-')) return `SANS ${mod.slice(1)}`;
  if (mod.startsWith('+')) return `+ ${mod.slice(1)}`;
  return mod;
}

// Durée (ms) -> "N min" ou "H h MM min" (bilan fin de service).
export function formatDuree(ms: number): string {
  const totalMin = Math.max(0, Math.round(ms / 60_000));
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  return h === 0 ? `${m} min` : `${h} h ${String(m).padStart(2, '0')} min`;
}

// Epoch ms -> "JJ/MM/AAAA" (date locale du bilan).
export function formatDateFr(epoch: number): string {
  const d = new Date(epoch);
  const jj = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  return `${jj}/${mm}/${d.getFullYear()}`;
}
